import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const View = (props) => {
  const {
    posted,
    updated,
    title,
    description,
    assets,
    fork,
    live,
    tutorial,
    techList,
  } = props.location.state;
  const iconColor = "#a8b2d1";
  return (
    <>
      <Helmet>
        <title>{title} | CodeLab</title>
      </Helmet>
      <div className="col-md-12 viewDemo">
        <div className="top">
          <div className="left">
            <p>sketch of three.js</p>
            <span>created by quan.le</span>
            <div className="links">
              <ul>
                {/* GitHub */}
                <li className="list-inline-item">
                  <a
                    href={fork}
                    target="_blank"
                    rel="noreferrer"
                    title={`Fork:${title}`}
                  >
                    <svg
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      fill={iconColor}
                    >
                      <path d="M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm3.163 21.783h-.093a.513.513 0 0 1-.382-.14.513.513 0 0 1-.14-.372v-1.406c.006-.467.01-.94.01-1.416a3.693 3.693 0 0 0-.151-1.028 1.832 1.832 0 0 0-.542-.875 8.014 8.014 0 0 0 2.038-.471 4.051 4.051 0 0 0 1.466-.964c.407-.427.71-.943.885-1.506a6.77 6.77 0 0 0 .3-2.13 4.138 4.138 0 0 0-.26-1.476 3.892 3.892 0 0 0-.795-1.284 2.81 2.81 0 0 0 .162-.582c.033-.2.05-.402.05-.604 0-.26-.03-.52-.09-.773a5.309 5.309 0 0 0-.221-.763.293.293 0 0 0-.111-.02h-.11c-.23.002-.456.04-.674.111a5.34 5.34 0 0 0-.703.26 6.503 6.503 0 0 0-.661.343c-.215.127-.405.249-.573.362a9.578 9.578 0 0 0-5.143 0 13.507 13.507 0 0 0-.572-.362 6.022 6.022 0 0 0-.672-.342 4.516 4.516 0 0 0-.705-.261 2.203 2.203 0 0 0-.662-.111h-.11a.29.29 0 0 0-.11.02 5.844 5.844 0 0 0-.23.763c-.054.254-.08.513-.081.773 0 .202.017.404.051.604.033.199.086.394.16.582A3.888 3.888 0 0 0 5.702 10a4.142 4.142 0 0 0-.263 1.476 6.871 6.871 0 0 0 .292 2.12c.181.563.483 1.08.884 1.516.415.422.915.75 1.466.964.653.25 1.337.41 2.033.476a1.828 1.828 0 0 0-.452.633 2.99 2.99 0 0 0-.2.744 2.754 2.754 0 0 1-1.175.27 1.788 1.788 0 0 1-1.065-.3 2.904 2.904 0 0 1-.752-.824 3.1 3.1 0 0 0-.292-.382 2.693 2.693 0 0 0-.372-.343 1.841 1.841 0 0 0-.432-.24 1.2 1.2 0 0 0-.481-.101c-.04.001-.08.005-.12.01a.649.649 0 0 0-.162.02.408.408 0 0 0-.13.06.116.116 0 0 0-.06.1.33.33 0 0 0 .14.242c.093.074.17.131.232.171l.03.021c.133.103.261.214.382.333.112.098.213.209.3.33.09.119.168.246.231.381.073.134.15.288.231.463.188.474.522.875.954 1.145.453.243.961.364 1.476.351.174 0 .349-.01.522-.03.172-.028.343-.057.515-.091v1.743a.5.5 0 0 1-.533.521h-.062a10.286 10.286 0 1 1 6.324 0v.005z" />
                    </svg>
                  </a>
                </li>
                {/* Live */}
                <li className="list-inline-item">
                  <a
                    href={live}
                    target="_blank"
                    rel="noreferrer"
                    title={`Live:${title}`}
                  >
                    <svg
                      x="0px"
                      y="0px"
                      width="32px"
                      height="32px"
                      viewBox="0 0 32 32"
                    >
                      <path
                        fill={iconColor}
                        d="M26.75,5.25c-4.081-2.077-9.546-1.767-13.471,2.158c-0.983,0.983-1.773,1.914-2.424,2.79
	l-0.028-0.028c-1.56-1.56-4.097-1.56-5.657,0s-1.56,4.097,0,5.657l0.51,0.51l2.671-1.335c-0.374,1.324-0.356,2.079-0.258,2.776
	l6.131,6.131c0.696,0.097,1.451,0.116,2.776-0.258l-1.336,2.671l0.51,0.51c1.56,1.56,4.097,1.56,5.657,0s1.56-4.097,0-5.657
	l-0.028-0.028c0.876-0.652,1.807-1.441,2.79-2.424C28.464,14.85,28.862,9.398,26.75,5.25z M6.187,13.847
	c-0.346-0.741-0.214-1.652,0.397-2.263c0.78-0.78,2.049-0.78,2.828,0l0.31,0.31c-0.051,0.087-0.108,0.177-0.156,0.262L6.187,13.847z
	 M20.416,22.588c0.78,0.78,0.78,2.048,0,2.828c-0.611,0.611-1.522,0.743-2.263,0.397l1.691-3.38
	c0.085-0.048,0.175-0.105,0.262-0.156L20.416,22.588z M15.115,21.971l-5.09-5.09c0.043-0.91,0.526-3.917,4.668-8.06
	c4.3-4.3,9.287-2.611,10.559-2.074c0.538,1.276,2.225,6.261-2.074,10.559C19.06,21.425,16.043,21.923,15.115,21.971z M16.643,12.357
	c0,1.654,1.346,3,3,3c1.654,0,3-1.346,3-3c0-1.654-1.346-3-3-3C17.989,9.357,16.643,10.703,16.643,12.357z M20.643,12.357
	c0,0.551-0.448,1-1,1c-0.552,0-1-0.449-1-1c0-0.551,0.448-1,1-1S20.643,11.806,20.643,12.357z M4.879,22.878
	c-1.007,1.007-1.02,3.522-1,4.27l0.027,0.946l1.164,0.029c1.391,0,3.223-0.174,4.051-1.001c1.175-1.176,1.17-3.072,0-4.243
	C7.988,21.745,6.012,21.746,4.879,22.878z M7.708,25.706c-0.152,0.139-0.787,0.323-1.805,0.391c0.062-0.849,0.215-1.61,0.39-1.803
	c0.39-0.389,1.021-0.392,1.414,0C8.099,24.683,8.097,25.319,7.708,25.706z"
                      />
                    </svg>
                  </a>
                </li>

                {/* Hashnode */}
                {tutorial && (
                  <li className="list-inline-item">
                    <a
                      href={tutorial}
                      target="_blank"
                      rel="noreferrer"
                      title={title}
                    >
                      <svg
                        width="337"
                        height="337"
                        role="img"
                        viewBox="0 0 337 337"
                        fill={iconColor}
                      >
                        <rect
                          x="113"
                          y="113"
                          width="111"
                          height="111"
                          rx="55.5"
                          fill="none"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M23.155 112.598c-30.873 30.874-30.873 80.93 0 111.804l89.443 89.443c30.874 30.873 80.93 30.873 111.804 0l89.443-89.443c30.873-30.874 30.873-80.93 0-111.804l-89.443-89.443c-30.874-30.873-80.93-30.873-111.804 0l-89.443 89.443zm184.476 95.033c21.612-21.611 21.612-56.651 0-78.262-21.611-21.612-56.651-21.612-78.262 0-21.612 21.611-21.612 56.651 0 78.262 21.611 21.612 56.651 21.612 78.262 0z"
                        />
                      </svg>
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <div className="right">
            <Link
              to="/works"
              spy={true}
              smooth={true}
              title="Works"
              duration={500}
            >
              Back
            </Link>
          </div>
        </div>
        <div className="col-md-12 view">
          <div className="bottom">
            <h2>{title}</h2>
            {updated ? (
              <span>
                posted: {posted} / updated: {updated}
              </span>
            ) : (
              <span>posted: {posted}</span>
            )}
            <p>{description}</p>
            {/*{assets && (
              <p className="assets">
                Assets:{"  "}
                <a href={assets}>Sketchfab.com</a>
              </p>
            )}
            <div className="project-tech-list">
              {techList &&
                techList.map((detail) => {
                  return (
                    <ul key={detail.id}>
                      <li>{detail.content}</li>
                    </ul>
                  );
                })}
            </div>*/}
            
          </div>
        </div>
        <iframe
          src={live}
          style={{
            width: "100%",
            height: "100%",
            border: "0",
            overflow: "hidden",
          }}
          title="fit-camera-to-object"
        ></iframe>
      </div>
    </>
  );
};

export default View;
